import { render, staticRenderFns } from "./carousel_widget.vue?vue&type=template&id=274c7f4d&scoped=true&lang=pug"
import script from "./carousel_widget.vue?vue&type=script&lang=js"
export * from "./carousel_widget.vue?vue&type=script&lang=js"
import style0 from "./carousel_widget.vue?vue&type=style&index=0&id=274c7f4d&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "274c7f4d",
  null
  
)

export default component.exports